// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__26d4v","clinicsSelect":"styles_clinicsSelect__106vU"};